import React, { useRef } from "react";
import { usePopupClickOutside } from "../../../../hooks/usePopupClickOutside";
import FaceIndexingForm from "./FaceIndexingForm";
interface SelfiePreferenceModalProps {
  onClose: () => void;
  reloadAlbumData: () => void;
  canUpdateSelfiePreference: boolean;
}

const SelfiePreferenceModal: React.FC<SelfiePreferenceModalProps> = ({
  onClose,
  reloadAlbumData,
  canUpdateSelfiePreference
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  usePopupClickOutside(popupRef, () => onClose());

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--show geo-modal--small selfie-preference-modal"
        role="dialog"
      >
        <div className="modal-dialog filter-dialog-content" ref={popupRef}>
          <div className="modal-header">
            &nbsp;
            <button
              type="button"
              className="close confirm-close"
              onClick={onClose}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="geo-modal__header">
            <div className="p-header">Action Required</div>
            <span className="s-header">Enable Selfie Search </span>
          </div>

          <div className="modal-body">
            <div
              className={`modal-info ${
                !canUpdateSelfiePreference ? "info-bottom" : ""
              }`}
            >
              <span>
                You will need to determine if you'd like to use the Selfie
                Search feature before uploading photos.
              </span>
              <div className="info-text">
                This is an optional feature that allows people to find photos
                and videos quickly using face recognition. We provide this
                feature in accordance with our {" "}
                <a
                  href="/terms_and_conditions"
                  target="_blank"
                  className="link-content"
                >
                  Terms and Conditions
                </a>{" "}
                and{" "}
                <a
                  href="/privacy_policy"
                  target="_blank"
                  className="link-content"
                >
                  Privacy Policy
                </a>
              </div>

              <p>Would you like to enable selfie search?</p>
            </div>
            {canUpdateSelfiePreference && (
              <div className="yes-or-no-section">
                <FaceIndexingForm
                  onClose={onClose}
                  reloadAlbumData={reloadAlbumData}
                />
              </div>
            )}
          </div>
          <div className="account-settings-section">
            {canUpdateSelfiePreference ? (
              <div className="settings-content">
                You can set this at the Account level - update in the{" "}
                <a href="/users/edit#settings" className="link-content">
                   Account Settings
                </a>{" "}
                area
              </div>
            ) : (
              <div className="owner-settings-content">
                Please contact the event organizer.
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default SelfiePreferenceModal;
